<template>
  <img
    class="image"
    v-bind:src="url"
    v-bind:alt="alt"
  />
</template>

<script>
export default {
  name: 'Image',
  props: {
    url: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: false,
      default: '',
    }
  }
};
</script>

<style lang="scss">
  .image {
    width: 100%;
  }
</style>
